/** @jsxImportSource @emotion/react */
import Typography from '@mui/material/Typography'
import MuiTooltip, { TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip'
import * as classes from './styles'

export type TooltipProps = MuiTooltipProps & {
  isNote?: boolean
}

export const Tooltip = ({ isNote, title, children, ...props }: TooltipProps) => (
  <MuiTooltip
    {...props}
    title={
      <>
        {isNote && (
          <Typography variant="body2" css={classes.tooltipTitle}>
            Note
          </Typography>
        )}
        {title}
      </>
    }
  >
    <div css={classes.fullWidth}>{children}</div>
  </MuiTooltip>
)
